import React from 'react';

import { Box, Container, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { WheelsVehicle } from '../../domain/wheels';
import { useWheelsRoutesTable } from './use-wheels-routes-table';
import { WheelsRouteTable } from './route-table';

// ********************************************************************************
type Props = {};
export const WheelsRoutes = (props: Props) => {
  const { t } = useTranslation();
  const { routes } = useWheelsRoutesTable();

  // == Render =====================================================================
  return (
    <Box component="section" bgcolor="white" py={6}>
      <Container maxWidth="lg">
        <Stack spacing={3}>
          <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
            {t('wheels_service.wheels_price.routes.title')}
          </Typography>
          <Typography variant="body1" color="#302F2F" fontSize="18px" textAlign="left" lineHeight="20px" mt={2}>
            {t('wheels_service.wheels_price.routes.description')}
          </Typography>
        </Stack>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={3} mt={4} justifyContent="center" alignItems="center">
          <WheelsRouteTable data={routes[WheelsVehicle.Sedan]} type={WheelsVehicle.Sedan} />
          <WheelsRouteTable data={routes[WheelsVehicle.Transit]} type={WheelsVehicle.Transit} />
          <WheelsRouteTable data={routes[WheelsVehicle.Suv]} type={WheelsVehicle.Suv} />
        </Box>
      </Container>
    </Box>
  );
};
